import NextImage from 'components/NextImage/NextImage';
import styles from './NavigationListItem.module.css';
import SpaLink from 'components/SpaLink/SpaLink';
import classnames from 'classnames';
const NavigationListItem = ({
  title,
  imageUrl,
  href,
  onClick,
  className
}: {
  title: string;
  imageUrl: string;
  className?: string;
  href: string;
  onClick?: () => void;
}) => {
  return <li className={classnames(styles.item, className)} data-sentry-component="NavigationListItem" data-sentry-source-file="NavigationListItem.tsx">
      <div className={styles.imageOverlay} />
      <NextImage className={styles.categoryImage} src={imageUrl} alt={''} width={640} height={360} fallbackSrc="/images/categories/fallback.jpg" data-sentry-element="NextImage" data-sentry-source-file="NavigationListItem.tsx" />
      <SpaLink href={href} onClick={onClick} className={styles.categoryLink} data-trk-categories-menu={title} data-sentry-element="SpaLink" data-sentry-source-file="NavigationListItem.tsx">
        <span className={styles.linkText}>{title}</span>
      </SpaLink>
      <div className={styles.gradient} />
    </li>;
};
export default NavigationListItem;